import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';

interface ConversationIdFilterProps {
  filterIndex: number;
}

/**
 * Renders a text input for filtering sessions by conversation ID
 */
export const ConversationIdFilter = ({ filterIndex }: ConversationIdFilterProps) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const sessionId = useWatch({ control, name: `filters.${filterIndex}.sessionId` }) || '';

  const handleSessionIdChange = (value: string) => {
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, sessionId: value });
  };

  return (
    <Input
      id={`session-id-${filterIndex}`}
      type="text"
      placeholder={t('analytics.filters.conversationIdPlaceholder')}
      value={sessionId}
      onChange={(e) => handleSessionIdChange(e.target.value)}
      className="w-full"
    />
  );
};
